import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import { EditPayrocTerminalAccountPayload } from 'api/admin/stores/editPayrocTerminalAccount';
import { editPayrocTerminalAccount } from 'api/admin/stores/editPayrocTerminalAccount';

export const useEditPayrocTerminal = () => {
  return useMutation<unknown, AxiosError<{ error: string }>, EditPayrocTerminalAccountPayload>({
    mutationFn: async ({
      terminalId,
      storeId,
      payrocMerchantAccountId,
      payrocTerminalAccountId,
    }) => {
      return editPayrocTerminalAccount({
        terminalId,
        storeId,
        payrocMerchantAccountId,
        payrocTerminalAccountId,
      });
    },
    onSuccess: async () => {
      toaster('Payroc Terminal Account has been updated', {
        icon: '✅',
      });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toaster(error?.response?.data?.error ?? 'An error occurred while updating terminal account', {
        icon: '❌',
      });
      return error;
    },
  });
};
